/**
 *
 * UnauthorisedPage
 *
 */
import { useAuth0 } from '@auth0/auth0-react';
import { Box, Fab } from '@mui/material';
import { UrlFragments } from 'app/constants';
import React, { memo } from 'react';
import { history } from 'utils/history';
import image from 'app/assets/Empty-Member.png';
import { selectUnauthorisedFlag } from 'app/helpers/UseUnauthorisedHandler/slice/selectors';
import { useSelector } from 'react-redux';

interface Props {}
const { unauthorised } = UrlFragments;

export const UnauthorisedPage = memo((props: Props) => {
  const { logout, isAuthenticated } = useAuth0();
  const isUnauthorised = useSelector(selectUnauthorisedFlag);
  React.useEffect(() => {
    if (isAuthenticated && isUnauthorised) {
      logout({ returnTo: `${window.location.origin}/${unauthorised}` });
    }
  }, [logout, isAuthenticated, isUnauthorised]);

  const handleLogin = () => {
    history.push('/');
  };
  return (
    <Box
      width={'100vw'}
      height={'100vh'}
      position="absolute"
      top={0}
      left={0}
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
    >
      <Box color="primary.main">
        <h1>403</h1>
      </Box>
      <Box pb={2} color="primary.main">
        <h2>Sorry for the broken road!</h2>
      </Box>
      <Box pb={4}>
        <img src={image} alt="Empty search result" />
      </Box>
      <Box>
        <Fab
          size="small"
          variant="extended"
          aria-label="Login"
          color="secondary"
          onClick={handleLogin}
        >
          Login
        </Fab>
      </Box>
    </Box>
  );
});
